import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { editApplicationByIdFailed, editApplicationByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* editApplicationById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/proxy/backend/api/v1/resources/applications/${action.payload.id}`;
    const response = yield makeRequest(url, action.payload, action, 'PUT', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(editApplicationByIdSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(editApplicationByIdFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(editApplicationByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
